import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { SnIncident } from '@lib/api/entities';
import { SnIncidentsAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';
import { AddNewIncidentComponent } from '@lib/incidents';
import { t } from '@lib/translation';

@Component({
  selector: 'fs-sentry-vault',
  templateUrl: './sentry-vault.component.html',
  styleUrls: ['./sentry-vault.component.scss'],
})
export class SentryVaultComponent implements OnDestroy, OnInit {
  public form: UntypedFormGroup = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _incidentsAPI: SnIncidentsAPI,
    private readonly _dialogRef: MatDialogRef<SentryVaultComponent>,
    private readonly _matDialog: MatDialog,
    private readonly _cd: ChangeDetectorRef,
  ) {
    this._setFormFields();
  }

  public ngOnInit(): void {
    this._fetchData({});
  }

  private _setFormFields(): void {
    this.formFields = [
      {
        key: 'id',
        type: 'http-select',
        templateOptions: {
          label: t('map.drawing.selectCaseNumber'),
          valueProp: 'id',
          labelProp: 'caseNumber',
          fetchDataFn: this._fetchData.bind(this),
          required: true,
          emptyOption: false,
        },
      },
    ];
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onSubmit(): void {
    this._dialogRef.close(this.formModel);
  }

  public cancel(): void {
    this._dialogRef.close();
  }

  public addNewIncident(): void {
    const dialog = this._matDialog.open(AddNewIncidentComponent);

    dialog
      .afterClosed()
      .pipe(takeUntil(this._destroy$))
      .subscribe((res) => {
        if (res) {
          this.formModel = res;
          this._cd.detectChanges();
        }
      });
  }

  private _fetchData(params: ISnListQueryParameters): Observable<ISnListResponse<SnIncident>> {
    return this._incidentsAPI.getVaultIncidentList(params);
  }
}
